import AssistantIcon from "@mui/icons-material/Assistant";
import CloseIcon from "@mui/icons-material/Close";
import { ClickAwayListener, Paper, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import BNBox from "../BNBox/BNBox";
import BNIconButton from "../BNIconButton/BNIconButton";
import BNLink from "../BNLink/BNLink";
import BNButton from "../FormElements/BNButton/BNButton";

const LINK_PLACEHOLDER = "{link}";

interface Props {
  loginLink: string;
  text: string;
  linkLabel: string;
}

function renderTextWithLink(text: string, linkLabel: string, loginLink: string) {
  const [before, after] = text.split(LINK_PLACEHOLDER);
  if (after === undefined) {
    return <Fragment>{text}</Fragment>;
  }
  return (
    <Fragment>
      {before}
      <BNLink href={loginLink}>{linkLabel}</BNLink>
      {after}
    </Fragment>
  );
}

export function NobaChatLoginPrompt({ loginLink, text, linkLabel }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <BNBox
        sx={{
          position: "fixed",
          bottom: { xs: "6.4rem", md: "1.2rem" },
          right: { xs: "0.6rem", md: "1.2rem" },
          zIndex: 5000,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "1.2rem",
        }}
      >
        {open && (
          <Paper
            data-uit="noba-chat-login-prompt-panel"
            elevation={3}
            sx={{
              position: "relative",
              maxWidth: "32rem",
              p: "2rem",
              borderRadius: "1.2rem",
            }}
          >
            <BNIconButton
              data-uit="noba-chat-login-prompt-close"
              aria-label="Close"
              onClick={() => setOpen(false)}
              sx={{ position: "absolute", top: "0.4rem", right: "0.4rem" }}
            >
              <CloseIcon sx={{ width: 20, height: 20 }} />
            </BNIconButton>
            <Typography variant="body1">{renderTextWithLink(text, linkLabel, loginLink)}</Typography>
          </Paper>
        )}
        <BNButton
          onClick={() => setOpen((prevState) => !prevState)}
          data-uit="noba-chat-login-prompt-toggle"
          sx={{
            maxWidth: "initial",
            minWidth: "initial",
            width: 44,
            height: 44,
            px: 0,
            py: 0,
            borderRadius: "999.9rem",
          }}
        >
          <AssistantIcon sx={{ width: 20, height: 20 }} />
        </BNButton>
      </BNBox>
    </ClickAwayListener>
  );
}
